<template>
  <div class="containter">
    <div class="row" v-for="(item, index) in playerList" :key="index">
      <div>
        <div class="left">
          <div class="cover">
            <div v-if="item.audit_state == 1">
              <a :href="'/video?id=' + item.id" class="user">
                <img :src="item.cover"
              /></a>
            </div>
            <div v-if="item.audit_state != 1">
              <img :src="item.cover" />
            </div>
          </div>
          <div class="video-info">
            <h4>{{ (item.title==""||item.title==null)?item.playername:item.title }}</h4>
            <div class="date">{{ dateFormat(item.createdate) }}</div>
          </div>
        </div>
        <div class="right">
          <el-button icon="el-icon-edit" @click="edit(item.id)">编辑</el-button>
          <el-button icon="el-icon-delete" @click="del(item.id)">删除</el-button>
          <!-- <a :href="'/video?id=' + item.cont_id + '&uid=' + item.uid">编辑</a>
          <a :href="'/video?id=' + item.cont_id + '&uid=' + item.uid">删除</a> -->
        </div>
      </div>
      <div class="divider"></div>
      <div style="clear: both"></div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalNum"
      :page-size="10"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<style scoped>
.containter {
  background-color: white;
  padding: 16px;
  font-size: 15px;
}
.row {
  padding: 12px;
}
.user {
  font-weight: bold;
  margin-right: 8px;
}
.date {
  color: #999;
  font-size: 12px;
  line-height: 22px;
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.divider {
  background-color: #e2e2e2;
  height: 0.5px;
  width: 100%;
  float: right;
  margin-top: 12px;
  margin-bottom: 12px;
  padding-left: 12px;
}
.left {
  float: left;
  text-align: left;
}
.cover {
  float: left;
}
.video-info {
  width: 350px;
}
.right {
  float: right;
}
</style>

<script>
export default {
  data() {
    return {
      totalNum: 0,
      playerList: [],
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
    };
  },
  mounted() {
    this.getTotalNum();
    this.getList(1);
  },
  methods: {
    dateFormat(date) {
      return date.replace("T", " ").split(".")[0];
    },
    getTotalNum() {
      this.$http
        .get("/api/player")
        .then((r) => {
          this.totalNum = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getList(pageIndex) {
      this.$http
        .get("/api/adminplayer/" + pageIndex)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.playerList = r.data.data;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    edit(id) {
      this.$router.push({name:'playeredit',query:{id:id}});
    },
    del(id) {
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.delete("/api/adminplayer/" + id).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          }).catch(err=>{
            console.log(err);
          });
        })
        .catch(() => {
        });
    },
    handleCurrentChange(pageIndex) {
      this.getList(pageIndex);
    },
  },
};
</script>
